import { FREE_PLAN, PLAN_MARKETING, formatCheckIntervalLabel } from '../planMarketing'

export const EMAIL_UPTIME_ALERTS_SECTIONS = [
  {
    heading: 'Why email uptime alerts?',
    paragraphs: [
      'Not everyone lives in Slack. Email alerts reach stakeholders, on-call contacts, and clients who need to know about downtime without joining your workspace.',
      'Pingscalate lets you add email recipients directly on escalation policies—alongside Slack alerts, not instead of them.',
    ],
  },
  {
    heading: 'How email alerts work in Pingscalate',
    paragraphs: [
      'When you create or edit an escalation policy, add one or more email recipients. Each monitor linked to that policy sends alerts to those addresses when checks fail or SSL/domain expiry thresholds are crossed.',
      'Recovery notifications follow the same policy, so your team knows when an incident is resolved.',
    ],
  },
  {
    heading: 'Email recipient limits by plan',
    paragraphs: [
      `The free plan supports up to ${PLAN_MARKETING.free.emailRecipients} email recipient per escalation policy. Pro supports ${PLAN_MARKETING.pro.emailRecipients}; Max supports ${PLAN_MARKETING.max.emailRecipients}.`,
      'Slack alerts are unlimited by channel—you choose where messages land when you connect your workspace.',
    ],
  },
  {
    heading: 'Combine Slack and email',
    paragraphs: [
      'Use both channels on the same policy: Slack for the engineering channel, email for executives or external contacts. Escalation policies control recheck intervals and high-priority escalation for persistent failures.',
    ],
  },
  {
    heading: 'Getting started',
    paragraphs: [
      `Sign up for a free account, add monitors, and configure an escalation policy with email recipients. The free plan includes ${FREE_PLAN.monitors} monitors, ${formatCheckIntervalLabel(FREE_PLAN.intervalMinutes)}, and Slack and email alerts—no credit card required.`,
    ],
  },
] as const
